import { createAction } from 'redux-actions';
import { createReducer } from 'redux-create-reducer';
import { assoc, pipe, prop, curryN, equals, and, ifElse, always } from 'ramda';
import { createSelector } from 'reselect';
import { select, combineEpics, createEpicMiddleware } from 'redux-most';
import { map } from 'most';
import 'react';
import { setDisplayName, compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

var prefix = '@@team-griffin/redux-modal-router/M_';

// Types
var OPENED = prefix + 'OPENED';
var CLOSED = prefix + 'CLOSED';
var NAVIGATED = prefix + 'NAVIGATED';

// Creators
var opened = createAction(OPENED);
var closed = createAction(CLOSED);
var navigated = createAction(NAVIGATED);

var messages = Object.freeze({
	OPENED: OPENED,
	CLOSED: CLOSED,
	NAVIGATED: NAVIGATED,
	opened: opened,
	closed: closed,
	navigated: navigated
});

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _createReducer;

var initialState = {
  open: false,
  route: null,
  params: {}
};

var reducer = createReducer(initialState, (_createReducer = {}, defineProperty(_createReducer, OPENED, function (state, action) {
  return pipe(assoc('open', true), assoc('route', action.payload.route), assoc('params', action.payload.params))(state);
}), defineProperty(_createReducer, CLOSED, function (state, action) {
  return pipe(assoc('open', false), assoc('route', null), assoc('params', {}))(state);
}), defineProperty(_createReducer, NAVIGATED, function (state, action) {
  return pipe(assoc('open', true), assoc('route', action.payload.route), assoc('params', action.payload.params))(state);
}), _createReducer));

var prefix$1 = '@@team-griffin/redux-modal-router/S_';

// Types
var OPEN = prefix$1 + 'OPEN';
var CLOSE = prefix$1 + 'CLOSE';
var NAVIGATE = prefix$1 + 'NAVIGATE';

// Creators
var open = createAction(OPEN);
var close = createAction(CLOSE);
var navigate = createAction(NAVIGATE);

var signals = Object.freeze({
	OPEN: OPEN,
	CLOSE: CLOSE,
	NAVIGATE: NAVIGATE,
	open: open,
	close: close,
	navigate: navigate
});

var REDUCER_MOUNT_POINT = 'modalRouter';

var getModal = prop(REDUCER_MOUNT_POINT);

var isOpen = createSelector(getModal, prop('open'));

var selectors = Object.freeze({
	getModal: getModal,
	isOpen: isOpen
});

var curry2 = curryN(2);
var mmapc = curry2(map);

var openEpic = function openEpic(actions$) {
  return pipe(select(OPEN), mmapc(function (action) {
    return opened(action.payload);
  }))(actions$);
};

var closeEpic = function closeEpic(actions$) {
  return pipe(select(CLOSE), mmapc(function (action) {
    return closed();
  }))(actions$);
};

var navigateEpic = function navigateEpic(actions$) {
  return pipe(select(NAVIGATE), mmapc(function (action) {
    return navigated(action.payload);
  }))(actions$);
};

var rootEpic = combineEpics([openEpic, closeEpic, navigateEpic]);

var PureModalRoute = function PureModalRoute(_ref) {
  var matched = _ref.matched,
      render = _ref.render,
      params = _ref.params,
      closeModal = _ref.closeModal;
  return ifElse(equals(true), function () {
    return render({
      params: params,
      closeModal: closeModal
    });
  }, always(null))(matched);
};

var enhance = compose(setDisplayName('ModalRoute'));

var ModalRoute = enhance(PureModalRoute);

var pathMatch = equals;
var doesMatch = function doesMatch(isOpen$$1, path, route) {
  return and(isOpen$$1, pathMatch(path, route));
};

var mapStateToProps = function mapStateToProps(state, props) {
  var modal = getModal(state);

  return {
    matched: doesMatch(isOpen(state), props.path, modal.route),
    params: modal.params
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeModal: close
  }, dispatch);
};

var enhance$1 = compose(connect(mapStateToProps, mapDispatchToProps));

var ConnectedModalRoute = enhance$1(ModalRoute);

var middleware = createEpicMiddleware(combineEpics([rootEpic]));

var epic = rootEpic;
var ModalRoute$1 = ConnectedModalRoute;

export { reducer, signals, messages, selectors, REDUCER_MOUNT_POINT, middleware, epic, ModalRoute$1 as ModalRoute };
